"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$consentPreferences = void 0;
const nanostores_1 = require("nanostores");
const api_1 = require("./api");
const utils_1 = require("./utils");
exports.$consentPreferences = (0, nanostores_1.atom)(api_1.defaultConsentState);
api_1.hubspotAPI.addPrivacyConsentListener((newConsent) => {
    const cleanPreferences = (0, utils_1.omit)(newConsent, 'previousCategories');
    if (!(0, utils_1.isEqual)(exports.$consentPreferences.get(), cleanPreferences)) {
        exports.$consentPreferences.set(cleanPreferences);
    }
});
